<template src="../../../../components/shared/contacts/NewContactTemplate.html">

</template>

<script>
    import GenericProfileInfo from "../../../../components/shared/GenericProfileInfo.vue";
    import {api} from "../../../../global/framework/api.js";

    export default {
        name: "NewContactModal",
        props: {consultantId: {type: [Number], required: true}},
        components: {GenericProfileInfo},
        data() {
            return {
                vm: {},
                profileInfoData: {},
                isCompany: false
            }
        },
        methods: {
            async showModal() {
                let data = await api.get("Shared", this.consultantId, "GetAddContactModel");
                this.mapData('vm', data);
                this.mapData('profileInfoData', data);
                this.$refs.modalRef.open();
            },
            closeModal() {
                this.$refs.modalRef.close();
            },
            async addNewContact() {
                let result = await api.post("PsrContact", "SaveNewContact", {...this.$data.vm, ...this.$data.profileInfoData});
                if (result) {
                    this.$refs.modalRef.close();
                    this.$bus.$emit(this.$bus.$AcEvents.CONTACT_CHANGE, result);
                }
            }
        }
    }
</script>

<style scoped>
    .box {
        min-height: 100px !important;
    }
</style>